import { render, staticRenderFns } from "./StructureBinaryPartnerItem.vue?vue&type=template&id=2a838a68"
import script from "./StructureBinaryPartnerItem.vue?vue&type=script&lang=js"
export * from "./StructureBinaryPartnerItem.vue?vue&type=script&lang=js"
import style0 from "./StructureBinaryPartnerItem.vue?vue&type=style&index=0&id=2a838a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports